import { render, staticRenderFns } from "./double-scrollbar.vue?vue&type=template&id=34456f17&"
import script from "./double-scrollbar.vue?vue&type=script&lang=js&"
export * from "./double-scrollbar.vue?vue&type=script&lang=js&"
import style0 from "./double-scrollbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports